import { H5, P, TypographyContainer } from "@/components/Typography";
/**
 * OnboardingSection component that wraps around HeaderTextBlock
 * and provides a consistent styling for onboarding sections
 */
const OnboardingSection = ({
  heading,
  description,
}: IMatConfigurationSectionProperty) => {
  return (
    <TypographyContainer>
      <H5 className="mb-10 font-semibold">{heading}</H5>
      <P>{description}</P>
    </TypographyContainer>
  );
};

export default OnboardingSection;
